<template>
  <div :class="animeClass">
    <slot name="default">

    </slot>
  </div>
</template>
<script>
export default {
  props: {
    config: { type: Object, default: null }
  },
  data () {
    return {
      animeClass: '',
    }
  },
  watch: {
    config: {
      handler (nV, oV) {
        if (this.config && this.config['anime']) {
          this.animeClass = this.config['anime']
          console.log(this.animeClass)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
@-webkit-keyframes scale {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.2); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
}

.anime_scale {
  -webkit-animation: scale 2s ease-in-out infinite;
}
</style>